import { UpdateResource } from 'src/helpers/api/updates';
import { RichUpdatesState } from 'src/redux/modules/richUpdates/reducer';

export function getUpdates(richUpdates: RichUpdatesState): UpdateResource[] {
  return richUpdates.allUpdateIds.map((id: number) => {
    return richUpdates.updatesById[id];
  });
}
